<template>
  <div class="notification-grid">
    <profile-avatar
      :presetProfilePic="notification.notificationData.author.profilePicture"
      :username="notification.notificationData.author.username"
      :size="$vuetify.breakpoint.xs ? 32 : 48"
    ></profile-avatar>
    <div class="notification-message">
      <router-link :to="{ name: 'profile', params: { username: notification.notificationData.author.username } }">{{
        notification.notificationData.author.username
      }}</router-link>
      <br />
      commented on your
      <router-link :to="{ name: 'review', params: { id: notification.notificationData.reviewId } }" class="review-link">
        review
        <span v-if="notification.notificationData.work.title"
          >of <i>{{ notification.notificationData.work.title }}</i></span
        >
      </router-link>
      <br />
      <span class="notification-timestamp">
        {{ relativeDateString(new Date(notification.timeCreated).getTime()) }}
      </span>
    </div>
    <v-btn
      class="notification-action"
      color="primary"
      elevation="0"
      small
      :to="{ name: 'review', params: { id: notification.notificationData.reviewId } }"
      >view post</v-btn
    >
  </div>
</template>

<script>
import { relativeDateString } from "../../util/dateHelpers";

export default {
  name: "comment-notification",

  props: {
    notification: Object,
  },

  data: () => ({
    reviewWorkTitle: "",
  }),

  methods: {
    relativeDateString,
  },
};
</script>

<style scoped>
.notification-row .notification-message {
  grid-column: 2 / span 2;
}
</style>
